export const IncorrectCircleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="9" cy="9" r="9" fill="currentColor" />
      <line x1="12.9269" y1="5.09482" x2="5.01385" y2="13.0078" stroke="white" strokeWidth="2.5" />
      <line x1="12.9853" y1="13.0128" x2="5.07225" y2="5.09979" stroke="white" strokeWidth="2.5" />
    </svg>
  );
};
